export const buildDate = new Date('2026-10-30T11:47:40.481Z');
